import React from 'react';

const Sop = () => {
  const sopResources = [
    { label: "SOP for USA", url: "./pdf/sop-for-usa.pdf" },
    { label: "SOP for UK", url: "./pdf/sop-for-uk.pdf" },
    { label: "SOP for UK_Birmingham", url: "./pdf/sop-for-uk-brimingham.pdf" },
    { label: "SOP for Australia", url: "./pdf/sop-for-australia.pdf" },
    { label: "SOP for Ireland", url: "./pdf/sop-for-ireland.pdf" },
  ];

  return (
    <div className="edu-privacy-policy-area bg-white mt-10 p-8 rounded-lg shadow-md max-w-4xl w-full mx-auto">
      <h2 className="text-2xl font-semibold text-indigo-700 mb-6 text-center">
        SOP Resources
      </h2>
      {sopResources.map((item, i) => (
        <a
          key={i}
          href={item.url}
          download
          className="block px-4 py-3 bg-indigo-50 rounded-md font-bold text-indigo-700 underline hover:bg-indigo-100 transition mb-2"
        >
          {item.label}
        </a>
      ))}
    </div>
  );
};

export default Sop;
